var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tipsType,
            expression: "tipsType",
          },
        ],
        staticClass: "ERP_modal",
        attrs: { id: "modal" },
      },
      [
        _c(
          "a-modal",
          {
            attrs: {
              visible: _vm.showERPModal,
              getContainer: _vm.getContainer,
              footer: null,
              closable: false,
              centered: true,
              maskClosable: false,
              width: "492px",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "modalBox",
                class: _vm.tipsType == 2 ? "order-end" : "capacity-end",
              },
              [
                _vm.tipsType == 2
                  ? _c("div", [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("ERP单量已用完"),
                      ]),
                      _c("p", { staticClass: "text" }, [
                        _vm._v(
                          "您的ERP单量已用完，为了避免影响团队的正常使用，请尽快完成续费"
                        ),
                      ]),
                    ])
                  : _c("div", [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("ERP已经到期"),
                      ]),
                      _c("p", { staticClass: "text" }, [
                        _vm._v(
                          "您当前服务已经过期，过期后将无法使用易仓科技服务。为了避免影响团队的正常使用，请尽快完成续费"
                        ),
                      ]),
                    ]),
                _c("div", { staticClass: "buy_btn", on: { click: _vm.open } }, [
                  _vm._v("立即续费"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "click_btn",
                    on: {
                      click: function ($event) {
                        _vm.showERPModal = false
                        _vm.showTips = true
                      },
                    },
                  },
                  [_vm._v("我知道了")]
                ),
              ]
            ),
          ]
        ),
        _vm.showTips
          ? _c("div", [
              _c("div", { staticClass: "tipsMask" }),
              _c("div", { staticClass: "tipsCont" }, [
                _c("div", { staticClass: "txt" }, [
                  _vm._v(
                    "点击上方头像，进入“产品套餐“页面，即可进行续费等操作。"
                  ),
                ]),
                _c("div", [
                  _c("img", {
                    staticClass: "closeTips",
                    attrs: { src: require("../../assets/close-fill.png") },
                    on: {
                      click: function ($event) {
                        _vm.showTips = false
                      },
                    },
                  }),
                ]),
              ]),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }